<!-- js/components/Shared/Table.vue -->

<template>
  <div class="w-full text-xs md:text-sm">
    <div class="table-bottom p-2 grid grid-cols-1 md:grid-cols-2 md:gap-2" v-if="totalRows">
      <div class="tableresults flex flex-col lg:flex-row lg:space-x-4 items-center" v-if="totalRows && databaseTotal"><span
          class="text-lg">{{ parseInt(totalRows).toLocaleString() }} matching results.</span> <span
          class="text-sm">{{ parseInt(databaseTotal).toLocaleString() }} in database.</span></div>
      <div class="table-results" v-if="totalRows && !databaseTotal">Showing {{ parseInt(totalRows).toLocaleString() }}
        results
      </div>
      <table-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          :current-page="currentPage"
          v-on:selected-page="onSelectPage">
      </table-pagination>
    </div>

    <div class="p-2" v-if="$slots.options">
      <slot name="options"></slot>
    </div>

    <div class="table-wrapper">
      <table class="table-object">
        <thead>
        <tr is="table-header"
            :columns="columns"
            :rows="rows"
            :sort="sort.column"
            :direction="sort.direction"
            :multiselect="multiselect"
            v-on:sort-toggle="onSortToggle"
            v-on:table-select-all="tableSelectAll"
            v-on:table-unselect-all="tableUnselectAll"
        >
        </tr>
        </thead>
        <!-- @todo pass tag hexcode, convert to HSL for background. -->
        <tbody class="bg-cal-EFEFEF lg:bg-white">
        <tr is="table-row"
            v-for="(row, index) in rows"
            :key="`row-${index}`"
            :row="row"
            :columns="columns"
            :multiselect="multiselect"
            :checked="isChecked(row)"
            v-on:selected-row="onSelectRow"
            v-on:checked-row="onCheckRow">
        </tr>
        </tbody>
      </table>
    </div>


    <div class="table-empty" v-if="rows === null">
      <div class="p-4 items-center justify-center flex">
        <slot name="empty">Searching</slot>
      </div>
    </div>
    <div class="table-empty" v-if="rows && rows.length <= 0">
      <div class="p-4 items-center justify-center flex">
        <slot name="empty">No records</slot>
      </div>
    </div>

    <div class="p-2 flex flex-row items-center justify-center">
      <table-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          :current-page="currentPage"
          v-on:selected-page="onSelectPage">
      </table-pagination>
    </div>
  </div>
</template>

<script>

import TableHeader from './VueTableHeader.vue';
import TableRow from './VueTableRow.vue';
import TablePagination from './VueTablePagination.vue';
import TableCell from './VueTableCell.vue';

export default {

  components: {TableHeader, TableRow, TablePagination, TableCell},

  props: {
    columns: null,
    rows: null,
    totalRows: Number,
    databaseTotal: Number,
    perPage: Number,
    currentPage: Number,
    multiselect: {
      default: false
    }
  },

  data() {
    return {
      sort: {
        column: null,
        direction: null
      },
      selected: []
    }
  },

  methods: {
    onSelectRow(row, event) {
      this.$emit("selected-row", row, event);
    },

    onSelectPage(page) {
      this.$emit("selected-page", page)
    },

    isChecked(row) {
      return this.selected.indexOf(row) > -1;
    },

    onCheckRow(row) {
      const index = this.selected.indexOf(row);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(row);
      }
    },

    getSelected() {
      return this.selected;
    },

    onSortToggle(column) {

      if (this.sort.column == column && this.sort.direction == "asc") {
        this.sort.column = null;
        this.sort.direction = null;
      } else if (this.sort.column == column) {
        this.sort.column = column;
        this.sort.direction = "asc";
      } else {
        this.sort.column = column;
        this.sort.direction = "desc";
      }

      this.$emit("change-sort", this.sort);
    },

    tableSelectAll() {
      this.selected = this.rows;
    },
    tableUnselectAll() {
      this.selected = [];
    }
  },
  watch: {
    'selected': function () {
      this.$emit('table-rows-selected', this.selected);
    },
    'rows': function () {
      this.selected = [];
    }
  }
}
</script>

<style>

.table-wrapper {
  overflow: scroll;
}

@media screen and (max-width: 768px) {
  .table-wrapper {
    margin-bottom: 10px;
    border: none;
  }
}

.table-object {
  width: 100%;
  overflow: hidden;
  margin: 0;
}

.table-options {
  padding: 10px 0px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #DDD;
}

@media screen and (max-width: 480px) {
  .table-options {
    display: none;
  }
}

.table-options-left,
.table-options-right {
  width: 50%;
  flex-grow: 1;
}

.table-options-right {
  text-align: right;
}

.table-options h4 {
  font-weight: 500;
  font-size: 16px;
  color: #4A4A4A;
}

.table-results {
  color: #AAAAAA;
  padding: 10px 0px;
  font-size: 14px;
}

@media screen and (max-width: 768px) {
  .table-td.active {
    display: none;
  }
  thead {
    display: none;
  }
}

tr.new-project {
  background: #FFF !important;
}

tr {
  background: #F5F5F5;
}

@media screen and (max-width: 768px) {
  tr {
    display: block;
    margin-bottom: 1rem;
  }

  td {
    display: block;
  }

  td span {
    display: block;
    padding-left: 7rem;
  }

  td::before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
    width: 7rem;
  }
}

</style>
